import React, { useContext } from 'react';
import { AgendaContext } from '../../contexts/AgendaContext';
// Mui components
import { Box, Typography, Button } from '@mui/material';
// Images
import iconErrorPreLogin from '../../utils/images/icon-pre-login.png';

export default function PaginaPreLoginError({ message }) {
  const { logout } = useContext(AgendaContext);

  const reloadPage = async (e) => {
    e.preventDefault();
    await logout();
  };

  return (
    <>
      <Box>
        <img style={{ width: '4rem' }} src={iconErrorPreLogin} loading="lazy" />
      </Box>
      <Typography
        variant="h1"
        sx={{
          fontSize: '48px !important',
          lineHeight: '50px !important',
          color: '#1226AA'
        }}>
        Acceso no disponible
      </Typography>
      <Typography
        variant="h5"
        component="p"
        sx={{
          fontSize: '16px',
          color: '#1226AA'
        }}>
        {message}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        sx={{
          height: '48px',
          position: 'relative',
          padding: '0.5rem 2rem',
          marginTop: '2vh',
          borderRadius: '2vh',
          width: '100%'
        }}
        onClick={(e) => reloadPage(e)}>
        Volver al inicio
      </Button>
    </>
  );
}
